import React, { useEffect, useState } from "react";
import { api, imageUrl } from "@/lib/api";

export default function About() {
  const [artist, setArtist] = useState({
    name: "Colleen Prosser",
    bio: "",
    photo_path: "",
    statement: "",
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/artist-profile")
      .then((res) => setArtist(res.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div
      data-testid="about-page"
      className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20"
    >
      <p className="label-eyebrow fade-up">About the Artist</p>
      <h1 className="font-serif text-5xl md:text-6xl font-light text-[#2D2926] mt-4 tracking-tight fade-up-delay-1">
        {artist.name || "Colleen Prosser"}
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 lg:gap-20 mt-16">
        <div className="md:col-span-5 fade-up-delay-2">
          <div className="bg-[#EFEBE6] aspect-[4/5] overflow-hidden">
            {artist.photo_path ? (
              <img
                src={imageUrl(artist.photo_path)}
                alt={artist.name}
                className="w-full h-full object-cover"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center label-eyebrow text-[#5B5653]">
                Portrait
              </div>
            )}
          </div>
        </div>
        <div className="md:col-span-7 fade-up-delay-3">
          {artist.statement && (
            <p className="font-serif text-2xl md:text-3xl font-light text-[#2D2926] leading-tight italic">
              “{artist.statement}”
            </p>
          )}
          <div className="mt-10 text-[#5B5653] leading-relaxed whitespace-pre-wrap text-base">
            {loading
              ? "Loading…"
              : artist.bio ||
                "The artist's biography will appear here once added from the admin dashboard."}
          </div>
          <div
            data-testid="about-copyright-notice"
            className="mt-12 pt-8 border-t border-[#E3DDD7] text-xs text-[#5B5653] leading-relaxed"
          >
            <p>
              © {new Date().getFullYear()} Colleen Prosser. All artworks, photographs, and
              stories shown on this site are the copyright and cultural property of the artist
              and may not be reproduced without written permission.{" "}
              <a
                href="/copyright"
                className="underline underline-offset-4 hover:text-[#E25C46]"
              >
                Full copyright &amp; IP notice
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
